var map = {
	"./AlbertEinstein-svg.png": 7820,
	"./AlbertEinstein.png": 9182,
	"./AlbertEinstein.svg": 8783,
	"./HbcardTeleMedicina.svg": 2898,
	"./agenda.png": 3280,
	"./banner-hbcard.png": 9021,
	"./homeImg.png": 2248,
	"./logo-hbcard-25.png": 1624,
	"./logo-hbcard.png": 7924,
	"./logo.png": 3153,
	"./postimonialElement.png": 981,
	"./tokio-marine-seguradora.png": 2183,
	"./tokio-marine-seguradora.svg": 9379,
	"./video-julio.mp4": 3205,
	"./video-landing.mp4": 189,
	"./video2.mp4": 6037,
	"./yuki.png": 9270,
	"./zenilson.png": 6848
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;